<script setup>
import { isAvailableNow } from '@/utils/dates.js'

const page = usePage()
const { isBlogPage } = useBlogPage()

usePageHead()
</script>

<template>
  <div v-if="page && isAvailableNow(page)" :class="page.withoutVerticalSpace ? '' : 'mt-10'">
    <cms-block-renderer
      v-if="page.documentId && Array.isArray(page.blocks)"
      :blocks="page.blocks"
    />
  </div>

  <blog-overview v-else-if="isBlogPage" />
</template>
